export const translations = {
  es: {
    nav: {
      home: 'Inicio',
      services: 'Servicios',
      portfolio: 'Portfolio',
      about: 'Sobre mí',
      blog: 'Blog',
      contact: 'Contacto'
    },
    home: {
      hero: {
        title: 'Transformo Ideas en',
        subtitle: 'Experiencias Digitales',
        description: 'Freelancer especializado en desarrollo web y branding. Creo sitios que no solo se ven bien, sino que generan resultados.',
        cta: 'Ver mi trabajo',
        ctaSecondary: 'Hablemos'
      }
    },
    about: {
      hero: {
        title: 'De Artista a Creador Digital',
        subtitle: 'Transformo ideas en experiencias digitales con alma.',
        description: 'Combino sensibilidad artística, visión estratégica y excelencia técnica para crear sitios que no solo se vean bien —sino que se sientan bien.'
      },
      story: {
        title: 'Mi Historia',
        subtitle: 'Antes de escribir código, escribía canciones.',
        description: 'La música me enseñó a escuchar —a entender los silencios, los matices, los detalles que transforman algo bueno en algo inolvidable.',
        quote: 'La perfección técnica sin alma es solo ruido. Yo construyo experiencias que suenan y resuenan.'
      }
    },
    portfolio: {
      title: 'Portfolio',
      subtitle: 'Proyectos reales con resultados medibles',
      insights: {
        title: 'Reflexiones del Proceso',
        subtitle: 'Mi perspectiva sobre cada proyecto desarrollado'
      }
    },
    leRaffine: {
      nav: {
        menu: 'Menú',
        about: 'Nosotros',
        reservations: 'Reservas',
        contact: 'Contacto',
        viewBranding: 'Ver Branding'
      },
      hero: {
        subtitle: 'Experiencia culinaria francesa de alta cocina',
        cta: 'Reservar Mesa'
      },
      about: {
        title: 'Tradición & Elegancia',
        description1: 'En Le Raffiné, cada plato es una obra de arte culinaria que combina técnicas tradicionales francesas con ingredientes locales de la más alta calidad.',
        description2: 'Nuestro chef ejecutivo, formado en las mejores cocinas de París, crea experiencias gastronómicas únicas que despiertan todos los sentidos.',
        experience: 'Años de experiencia',
        michelin: 'Estrella Michelin'
      },
      menu: {
        title: 'Menú Degustación',
        dishes: {
          foieGras: 'Con reducción de oporto y brioche artesanal',
          bouillabaisse: 'Sopa tradicional marsellesa con mariscos frescos',
          beef: 'Costilla de res wagyu con jus de trufa'
        }
      },
      reservations: {
        title: 'Reservaciones',
        subtitle: 'Disponible de martes a sábado, de 19:00 a 23:00 horas',
        phone: 'Teléfono',
        email: 'Email',
        location: 'Ubicación',
        address: 'Calle Gourmet 123<br />Madrid, España'
      },
      footer: {
        description: 'Una experiencia culinaria única que combina la tradición francesa con la innovación contemporánea.',
        hours: 'Horarios',
        schedule: 'Martes - Sábado<br />19:00 - 23:00<br />Domingo - Lunes<br />Cerrado',
        contact: 'Contacto',
        copyright: '© 2025 Le Raffiné. Todos los derechos reservados.'
      }
    },
    empresaFamiliar: {
      hero: {
        title: 'Rebrand Empresa Familiar',
        description: 'Una empresa con 50 años de historia necesitaba modernizar su imagen para conectar con nuevas generaciones sin perder su esencia. Mi desafío fue crear una identidad que honrara el legado familiar y al mismo tiempo le diera frescura y relevancia en la era digital.',
        metric: 'Percepción moderna mejorada'
      },
      before: {
        title: 'El Antes',
        originalIdentity: 'Identidad Original',
        previousLogo: 'Logo Anterior',
        originalPalette: 'Paleta de Colores Original',
        previousCommunication: 'Comunicación Anterior',
        clickToView: 'Click para ver'
      },
      challenge: {
        title: 'El Desafío',
        modernize: 'Modernizar la identidad',
        modernizeDesc: 'Actualizar la imagen visual sin perder la esencia de 30 años',
        attract: 'Atraer nuevas generaciones',
        attractDesc: 'Conectar con audiencias más jóvenes y digitales',
        maintain: 'Mantener el legado',
        maintainDesc: 'Preservar la seriedad y confianza de la marca familiar',
        improve: 'Mejorar presencia digital',
        improveDesc: 'Optimizar la marca para plataformas digitales'
      },
      process: {
        title: 'El Proceso',
        research: 'Análisis de historia, valores y percepción actual',
        moodboard: 'Exploración visual y conceptual de la nueva dirección',
        exploration: 'Iteraciones de logo, tipografía y paleta de colores',
        implementation: 'Aplicación en todos los puntos de contacto'
      },
      result: {
        title: 'El Resultado',
        newIdentity: 'Nueva Identidad',
        newLogo: 'Nuevo Logo (Minimalista)',
        newPalette: 'Nueva Paleta (#4f192a + complementarios)',
        typography: 'Tipografía (Serif)',
        currentCommunication: 'Comunicación Actual',
        mockups: 'Mockups',
        stationery: 'Papelería',
        packaging: 'Empaques',
        digital: 'Digital',
        clickGallery: 'Click para ver galería'
      },
      impact: {
        title: 'Impacto del Rebrand',
        description: 'El rebrand logró posicionar a la empresa como una opción moderna y confiable, manteniendo su esencia familiar pero conectando efectivamente con nuevas generaciones. La percepción de modernidad aumentó un 90% y se incrementó significativamente la atracción de clientes jóvenes.',
        modernPerception: 'Percepción moderna',
        newCustomers: 'Nuevos clientes',
        satisfaction: 'Satisfacción',
        requestConsultation: 'Solicitar Consulta',
        viewMoreProjects: 'Ver Más Proyectos'
      },
      gallery: {
        descriptions: {
          businessCards: 'Tarjetas de presentación con nuevo branding',
          letterhead: 'Membrete y papel carta corporativo',
          envelopes1: 'Sobres y carpetas institucionales (1)',
          envelopes2: 'Sobres y carpetas institucionales (2)',
          productBox: 'Diseño de caja principal del producto - Línea Clásica',
          bottleDesign: 'Diseño Clásico en Botella - Mockup',
          limitedVideo: 'Video Edición Limitada - Especial 50 Años',
          socialMedia: 'Posts para redes sociales',
          webDesign: 'Diseño web responsive',
          digitalAds: 'Banners y material publicitario digital'
        },
        counter: 'de'
      }
    }
  },
  en: {
    nav: {
      home: 'Home',
      services: 'Services',
      portfolio: 'Portfolio',
      about: 'About',
      blog: 'Blog',
      contact: 'Contact'
    },
    home: {
      hero: {
        title: 'I Transform Ideas into',
        subtitle: 'Digital Experiences',
        description: 'Freelancer specialized in web development and branding. I create websites that not only look good, but generate results.',
        cta: 'View my work',
        ctaSecondary: 'Let\'s talk'
      }
    },
    about: {
      hero: {
        title: 'From Artist to Digital Creator',
        subtitle: 'I transform ideas into digital experiences with soul.',
        description: 'I combine artistic sensitivity, strategic vision and technical excellence to create sites that not only look good —but feel good.'
      },
      story: {
        title: 'My Story',
        subtitle: 'Before writing code, I wrote songs.',
        description: 'Music taught me to listen —to understand silences, nuances, the details that transform something good into something unforgettable.',
        quote: 'Technical perfection without soul is just noise. I build experiences that sound and resonate.'
      }
    },
    portfolio: {
      title: 'Portfolio',
      subtitle: 'Real projects with measurable results',
      insights: {
        title: 'Process Insights',
        subtitle: 'My perspective on each developed project'
      }
    },
    leRaffine: {
      nav: {
        menu: 'Menu',
        about: 'About',
        reservations: 'Reservations',
        contact: 'Contact',
        viewBranding: 'View Branding'
      },
      hero: {
        subtitle: 'French haute cuisine culinary experience',
        cta: 'Reserve Table'
      },
      about: {
        title: 'Tradition & Elegance',
        description1: 'At Le Raffiné, each dish is a culinary work of art that combines traditional French techniques with the highest quality local ingredients.',
        description2: 'Our executive chef, trained in the finest kitchens of Paris, creates unique gastronomic experiences that awaken all the senses.',
        experience: 'Years of experience',
        michelin: 'Michelin Star'
      },
      menu: {
        title: 'Tasting Menu',
        dishes: {
          foieGras: 'With port reduction and artisanal brioche',
          bouillabaisse: 'Traditional Marseille soup with fresh seafood',
          beef: 'Wagyu beef rib with truffle jus'
        }
      },
      reservations: {
        title: 'Reservations',
        subtitle: 'Available Tuesday to Saturday, 7:00 PM to 11:00 PM',
        phone: 'Phone',
        email: 'Email',
        location: 'Location',
        address: 'Gourmet Street 123<br />Madrid, Spain'
      },
      footer: {
        description: 'A unique culinary experience that combines French tradition with contemporary innovation.',
        hours: 'Hours',
        schedule: 'Tuesday - Saturday<br />7:00 PM - 11:00 PM<br />Sunday - Monday<br />Closed',
        contact: 'Contact',
        copyright: '© 2025 Le Raffiné. All rights reserved.'
      }
    },
    empresaFamiliar: {
      hero: {
        title: 'Family Business Rebrand',
        description: 'A company with 50 years of history needed to modernize its image to connect with new generations without losing its essence. My challenge was to create an identity that honored the family legacy while giving it freshness and relevance in the digital age.',
        metric: 'Improved modern perception'
      },
      before: {
        title: 'The Before',
        originalIdentity: 'Original Identity',
        previousLogo: 'Previous Logo',
        originalPalette: 'Original Color Palette',
        previousCommunication: 'Previous Communication',
        clickToView: 'Click to view'
      },
      challenge: {
        title: 'The Challenge',
        modernize: 'Modernize the identity',
        modernizeDesc: 'Update the visual image without losing 30 years of essence',
        attract: 'Attract new generations',
        attractDesc: 'Connect with younger and digital audiences',
        maintain: 'Maintain the legacy',
        maintainDesc: 'Preserve the seriousness and trust of the family brand',
        improve: 'Improve digital presence',
        improveDesc: 'Optimize the brand for digital platforms'
      },
      process: {
        title: 'The Process',
        research: 'Analysis of history, values and current perception',
        moodboard: 'Visual and conceptual exploration of the new direction',
        exploration: 'Logo, typography and color palette iterations',
        implementation: 'Application across all touchpoints'
      },
      result: {
        title: 'The Result',
        newIdentity: 'New Identity',
        newLogo: 'New Logo (Minimalist)',
        newPalette: 'New Palette (#4f192a + complementary)',
        typography: 'Typography (Serif)',
        currentCommunication: 'Current Communication',
        mockups: 'Mockups',
        stationery: 'Stationery',
        packaging: 'Packaging',
        digital: 'Digital',
        clickGallery: 'Click to view gallery'
      },
      impact: {
        title: 'Rebrand Impact',
        description: 'The rebrand successfully positioned the company as a modern and reliable option, maintaining its family essence while effectively connecting with new generations. Modern perception increased by 90% and significantly boosted attraction of young customers.',
        modernPerception: 'Modern perception',
        newCustomers: 'New customers',
        satisfaction: 'Satisfaction',
        requestConsultation: 'Request Consultation',
        viewMoreProjects: 'View More Projects'
      },
      gallery: {
        descriptions: {
          businessCards: 'Business cards with new branding',
          letterhead: 'Letterhead and corporate stationery',
          envelopes1: 'Institutional envelopes and folders (1)',
          envelopes2: 'Institutional envelopes and folders (2)',
          productBox: 'Main product box design - Classic Line',
          bottleDesign: 'Classic Bottle Design - Mockup',
          limitedVideo: 'Limited Edition Video - Special 50 Years',
          socialMedia: 'Social media posts',
          webDesign: 'Responsive web design',
          digitalAds: 'Banners and digital advertising material'
        },
        counter: 'of'
      }
    }
  }
};